import { Alert, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import TabsList from "../../../ui/TabsList";
import CustomTable from "../../../ui/CustomTable";
import Color from "./Render/Color";
import MakerCell from "./Render/MakerCell";
import { useNavigate, useParams } from "react-router-dom";
import { useMember } from "../provider";
import ErrorsList from "../../../ui/ErrorsList";
import { useAuth } from "../../../services/auth";
import ServicesRender from "./Render/ServicesRender";
import ModalBox from "../../../ui/ModalBox";
import PaymentDate from "./Render/PaymentDate";
import ActiveCell from './../../Companies/CompanyTable/ActiveCell';

const TableInfo = ({ member, reload }) => {
  const {
    state: { listPayments },
    fetchPayments,
    removeCar,
  } = useMember();
  const tabs = [
    {
      title: "Sites",
      num:
        member.planId === 3 ? member?.services?.length : member?.sites?.length,
    },
    { title: "Cars", num: member?.cars?.length },
    { title: "Payments", num: listPayments?.length },
  ];

  const [selectedCols, setSelectedCols] = useState("Sites");
  const [error, setError] = useState();
  const [openService, setOpenService] = useState(false);

  let navigate = useNavigate();
  const { id } = useParams();
  const { role } = useAuth();
  useEffect(() => {
    if (member?.id) fetchPayments(member?.id, {}, 1, 100);
  }, [member?.id, reload]);

  const getCols = (name) => {
    switch (name) {
      case "Sites":
        return [
          {
            label: "Site Name",
            name: member.planId === 3 ? "name" : "siteName",
            textLeft: true,
            headTextLeft: true,
          },
          member?.planId === 3 && {
            label: "Services",
            customRender: ServicesRender,
          },
        ];
      case "Cars":
        return [
          {
            label: "Plate",
            name: "plate",
            headTextLeft: true,
            textLeft: true,
          },

          {
            label: "Color",
            name: "color",
            customRender: Color,
          },
          {
            label: "Maker",
            name: "maker",
            customRender: MakerCell,
          },
          {
            label: "Status",
            name: "isActive",
            customRender: ActiveCell,
          },
        ];
      case "Payments":
        return [
          {
            label: "Payment Name",
            name: "paymentTypeName",
            headTextLeft: true,
            textLeft: true,
          },

          {
            label: "Amount",
            name: "amount",
          },
          {
            label: "Tip",
            name: "tip",
          },
          {
            label: "Employee",
            name: "employeeName",
          },
          {
            label: "Payment Date",
            name: "paymentDate",
            customRender: PaymentDate,
          },
        ];
      default:
        return;
    }
  };

  const getData = (name) => {
    switch (name) {
      case "Sites":
        if (member.planId === 3) {
          return member?.services||[];
        } else {
          return member?.sites||[];
        }
      case "Cars":
        return member?.cars||[];
      case "Payments":
        return listPayments||[];
      default:
        return;
    }
  };
  const handleAddNewCar = () => {
    navigate("/members/addCar/" + id);
  };
  const handleOpenServiceClose = () => {
    setOpenService(!openService);
  };
  const handleDelete = (id) => {
    try {
      removeCar(id);
    } catch (error) {
      setError({ title: error.errors.message });
    }
  };
  return (
    <Box sx={{ mt: 2 }}>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      <TabsList
        tabs={tabs}
        setSelectedCols={setSelectedCols}
        selectedCols={selectedCols}
      ></TabsList>

      <CustomTable
        empty={getData(selectedCols)?.length === 0}
        cols={getCols(selectedCols)}
        data={getData(selectedCols)}
        filters={{
          add:
            selectedCols === "Cars"
              ? handleAddNewCar
              : // : member?.planId === 3 && selectedCols === "Sites"
                // ? AddNewSiteWithService
                null,
        }}
        actions={
          selectedCols === "Cars" &&
          role !== "SubCompany" && {
            edit: (id) => {
              navigate(`/members/${member?.id}/updateCar/${id}`);
            },
            delete: (id) => {
              handleDelete(id);
            },
          }
        }
        isPagination={false}
      />
      <ModalBox
        open={openService}
        openService={true}
        member={member}
        handleClose={handleOpenServiceClose}
        text="The update operation has been completed successfully.."
        name={`${selectedCols}`}
      />
    </Box>
  );
};

export default TableInfo;
